<template>
  <div class="l-body">
    <Top/>
    <div class="wrap news_bg">
      <div class="news-jl-box_ls">
        <div class="ls-wrap zheng">
          <div class="news_list_tit">
            <h1>客服新闻/<span>NEWS</span></h1>
            <h2>当前位置：<a href="/">首页</a> > <a>新闻中心</a></h2>
          </div>
          <div class="news_list">
            <li v-for="news in newsData.data" @click='tonews(news.id)'>
			<router-link :to="{path:'/news', query:{id:news.id}}">
              <div class="riqi">
                <p class="ri">{{time2(news.time)}}</p>
                <p class="nianyue">{{time1(news.time)}}</p>
              </div>
              <div class="biaoti">
                <a>
                  <p class="news_tit">{{news.title}}</p>
                  <p class="news_jianjie">{{news.introduce}}</p>
                </a>
              </div>
              <div class="lailu"><a>新闻中心</a></div>
			  </router-link>
            </li>

          </div>
          <div class="page">
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="10"
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Top from '@/components/top.vue'
  export default {
    name: "news-list",
    components: {
      Top
    },
    data () {
      return {
        page:1,
        newsData:[],
        total:0,
      }
    },
    created() {
      this.getNews()
    },
    methods:{
      handleCurrentChange: function(currentPage){
        this.page = currentPage;
        this.getNews()
      },
      getNews() {
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/newslist',
          params: {
            page:this.page
          }
        }).then(res => {
          if(res.data.status==200) {
            this.total=res.data.count
            this.newsData = res.data
          }else{
            this.newsData=[]
            this.total = 0
          }
        })
      },
	  time1(val){
		return val.slice(0,7)
	  },
	  time2(val){
	  	return val.slice(8,10)	  
	  },
      tonews(id){
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/newscount',
          params: {
            id:id
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/news-list.vue